module.exports = __webpack_public_path__ + "static/media/star-filled.cb9072c5.svg";